__turbopack_context__.v({
  "container": "ProfilePic-module__PQQ5VG__container",
  "gradientBackground": "ProfilePic-module__PQQ5VG__gradientBackground",
  "profileImage": "ProfilePic-module__PQQ5VG__profileImage",
  "profileLink": "ProfilePic-module__PQQ5VG__profileLink",
});
